import { Row, Col, Space, Typography } from "antd";
import BorderedLink from "~/components/app/BorderedLink";
import { useRouter } from "next/router";
import { decodeTags, encodeTags } from "~/utils/post";

const { Text } = Typography;

const CategoryTagNavs = ({ category, preserveParams = [] }) => {
  if (!category || !category.tag_groups || category.tag_groups.length === 0)
    return null;

  const router = useRouter();
  const [pathname] = router.asPath.split("?");
  const tags = decodeTags(router.query.tags);

  const urlForTag = (index, tagId) => {
    const tagsCopy = [...tags];
    tagsCopy[index] = tagId;
    const tagsSegment = encodeTags(tagsCopy);

    // Preserve only specified query parameters
    const query = {};
    preserveParams.forEach((param) => {
      if (router.query[param] !== undefined) {
        query[param] = router.query[param];
      }
    });

    if (tagsSegment) {
      query.tags = tagsSegment;
    } else {
      delete query.tags;
    }

    // Build the query string
    const queryString = new URLSearchParams(query).toString();

    return queryString ? `${pathname}?${queryString}` : pathname;
  };

  const renderTagGroup = (tagGroup, index) => {
    return (
      <Row
        key={tagGroup.id}
        align="middle"
        gutter={[6, 10]}
        style={{ fontSize: "0.8rem" }}
      >
        <Col flex="80px">
          <Text strong>{tagGroup.name}</Text>
        </Col>
        <Col flex="1">
          <Row
            justify="start"
            align="middle"
            gutter={[6, 8]}
          >
            <Col>
              <BorderedLink
                href={urlForTag(index, 0)}
                key="all"
                active={!tags[index]}
              >
                全部
              </BorderedLink>
            </Col>
            {tagGroup.tags.map((tag) => (
              <Col key={tag.id}>
                <BorderedLink
                  href={urlForTag(index, tag.id)}
                  active={tags[index] === tag.id}
                >
                  {tag.name}
                </BorderedLink>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    );
  };

  return (
    <Space
      direction="vertical"
      size={10}
      style={{ display: "flex" }}
    >
      {category.tag_groups.map(renderTagGroup)}
    </Space>
  );
};

export default CategoryTagNavs;
